import { authFormInputsDefinition } from './inputDefinitions/authForm'
import { signUpFormDefinition } from './inputDefinitions/signUpForm'
import { restorePasswordDefinition } from './inputDefinitions/restorePasswordForm'
import { authSchema } from './zodSchema/authSchema'
import { restorePasswordSchema } from './zodSchema/restorePasswordSchema'
import { signUpSchema } from './zodSchema/signUpschema'
import { FormDefinition } from '../interface'

enum KeyOptions {
  auth = 'auth',
  signup = 'signup',
  restorepassword = 'restorepassword'
}

export const formsDefinitions: {
  [key in KeyOptions]: FormDefinition
} = {
  auth: {
    formTitle: 'Logowanie',
    inputs: authFormInputsDefinition,
    zodSchema: authSchema,
    submitBtn: {
      text: 'Zaloguj',
      id: 'loginButton'
    }
  },
  signup: {
    formTitle: 'Rejestracja',
    inputs: signUpFormDefinition,
    zodSchema: signUpSchema,
    submitBtn: {
      text: 'Zarejestruj się',
      id: 'signUpButton'
    }
  },
  restorepassword: {
    formTitle: 'Odzyskiwanie hasła',
    inputs: restorePasswordDefinition,
    zodSchema: restorePasswordSchema,
    submitBtn: {
      text: 'Przypomnij mi hasło',
      id: 'remindPasswordButton'
    }
  }
}
